import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Carousel, { slidesToShowPlugin } from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";

import PortFolioItem from "./PortFolioItem";
import { Button, Grid, IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import UseMobile from "../../hooks/useIsMobile";

const Background = "/images/abhipray/Intersect.png";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${Background})`,
    backgroundSize: `100% 100%`,
    backgroundRepeat: "no-repeat",
    height: 500,
    [theme.breakpoints.down("md")]: {
      backgroundImage: `none`,
      height: "100%",
      // backgroundColor: "green",
    },
  },
  description: {
    overflow: "hidden",
    display: "-webkit-box",

    height: "100%",
    // textOverflow: "ellipsis",
    // WebkitLineClamp: 5,
    // WebkitBoxOrient: "vertical",
  },
  caroiselContainer: {
    // backgroundColor: "red",
    height: 400,
    marginTop: "2vh",
    // width: "100%",
    // justifyContent: "center",
    // display: "flex",
    // alignItems: "center",
    [theme.breakpoints.down("md")]: {
      height: "100%",
      backgroundColor: "red",
    },
  },
  arrowIcon: {
    fontSize: "3rem",
    color: "white",
  },
  iconContainer: {
    height: "65vh",
  },
  dotItem: {
    height: "2vh",
    width: "2vh",
    borderRadius: 100,
    margin: 2,

    backgroundColor: "white",
  },
  activeDot: {
    backgroundColor: theme.palette.secondary.main,
  },
  icon: {
    color: theme.palette.secondary.main,
    border: "2px solid",
    borderColor: theme.palette.secondary.main,
    fontSize: "3rem",
    borderRadius: 100,
  },
  btnContainer: {
    paddingTop: theme.spacing(3),
  },
}));

const AbiprayCarousel = (props) => {
  const classes = useStyles();
  const isMobile = UseMobile();
  const careouselRef = React.useRef();
  const [value, setValue] = React.useState(0);
  const onChange = (e) => {
    setValue(e);
  };
  const SliderItems = props.data?.map((man, index) => {
    return <PortFolioItem data={man} />;
  });

  const PrevButton = () => {
    return (
      <IconButton onClick={() => careouselRef.current.slidePrev()}>
        <ChevronLeft className={classes.icon} />
      </IconButton>
    );
  };

  const NextButton = () => {
    return (
      <IconButton onClick={() => careouselRef.current.slideNext()}>
        <ChevronRight className={classes.icon} />
      </IconButton>
    );
  };

  return (
    <div className={classes.root}>
      <Grid
        container
        alignItems="center"
        justify="center"
        className={classes.btnContainer}
      >
        <Grid
          item
          justify="space-between"
          lg={10}
          container
          md={10}
          sm={12}
          xs={12}
        >
          <Grid item>
            <PrevButton />
          </Grid>
          <Grid item>
            <NextButton />
          </Grid>
        </Grid>
      </Grid>
      <Carousel
        slidesPerPage={isMobile ? 1 : 2}
        animationSpeed={1500}
        autoPlay={3000}
        stopAutoPlayOnHover
        infinite
        slides={SliderItems}
        clickToChange
        value={value}
        onChange={(e) => onChange(e)}
        breakpoints={{
          640: {
            plugins: [
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 1,
                },
              },
            ],
          },
          900: {
            plugins: [
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 1,
                },
              },
            ],
          },
        }}
      />
      {/* <AliceCarousel
        ref={careouselRef}
        mouseTracking
        autoPlay
        disableButtonsControls
        renderPrevButton={(props) => <Button {...props}>prev</Button>}
        disableDotsControls
        infinite
        autoPlayInterval={6000}
        mouseTracking
        items={SliderItems}
        responsive={{
          0: {
            items: 1,
          },
          1024: {
            items: 1,
            autoPlayInterval: 5000,
          },
        }}
      /> */}
    </div>
  );
};
export default AbiprayCarousel;

//horizontal old
// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// // import Swiper styles
// import { Grid, Hidden, IconButton } from "@material-ui/core";
// import PortFolioItem from "./PortFolioItem";

// import Swiper from "react-id-swiper";
// import "swiper/swiper-bundle.css";
// import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
// import clsx from "clsx";
// const Background = "/images/abhipray/Intersect.png";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     backgroundImage: `url(${Background})`,
//     backgroundSize: `100% 100%`,
//     backgroundRepeat: "no-repeat",
//     height: "65vh",
//     [theme.breakpoints.down("md")]: {
//       backgroundImage: `none`,
//       height: "350px",
//       backgroundColor: "green",
//     },
//   },
//   description: {
//     overflow: "hidden",
//     display: "-webkit-box",

//     height: "100%",
//     // textOverflow: "ellipsis",
//     // WebkitLineClamp: 5,
//     // WebkitBoxOrient: "vertical",
//   },
//   caroiselContainer: {
//     // backgroundColor: "red",
//     height: "57vh",
//     marginTop: "2vh",
//     // width: "100%",
//     // justifyContent: "center",
//     // display: "flex",
//     // alignItems: "center",
//     [theme.breakpoints.down("md")]: {
//       height: "320px",
//       backgroundColor: "red",
//     },
//   },
//   arrowIcon: {
//     fontSize: "3rem",
//     color: "white",
//   },
//   iconContainer: {
//     height: "65vh",
//   },
//   dotItem: {
//     height: "2vh",
//     width: "2vh",
//     borderRadius: 100,
//     margin: 2,

//     backgroundColor: "white",
//   },
//   activeDot: {
//     backgroundColor: theme.palette.secondary.main,
//   },
// }));

// const AbhiprayCarousel = (props) => {
//   const [firstSwiper, setFirstSwiper] = React.useState(null);
//   const classes = useStyles();
//   const [value, setValue] = React.useState(0);
//   const swiperRef = React.useRef();
//   const [currentIndex, updateCurrentIndex] = React.useState(0);
//   const onChange = (e) => {
//     setValue(e.target ? e.target.value : e);
//   };
//   const params = {
//     direction: "vertical",
//     slidesPerView: 2,

//     spaceBetween: 10,
//   };
//   const goNext = () => {
//     if (swiperRef.current && swiperRef.current.swiper) {
//       swiperRef.current.swiper.slideNext();
//       console.log("swiper", swiperRef.current.swiper);
//     }
//   };
//   const goPrev = () => {
//     if (swiperRef.current && swiperRef.current.swiper) {
//       swiperRef.current.swiper.slidePrev();
//     }
//   };
//   const updateIndex = React.useCallback(
//     () => updateCurrentIndex(swiperRef.current.swiper.realIndex),
//     []
//   );

//   React.useEffect(() => {
//     const swiperInstance = swiperRef.current.swiper;

//     if (swiperInstance) {
//       swiperInstance.on("slideChange", updateIndex);
//     }

//     return () => {
//       if (swiperInstance) {
//         swiperInstance.off("slideChange", updateIndex);
//       }
//     };
//   }, [updateIndex]);
//   return (
//     <div className={classes.root}>
//       <Grid container>
//         <Hidden mdDown>
//           <Grid
//             item
//             lg={1}
//             container
//             alignItems="center"
//             direction="column"
//             justify="center"
//             className={classes.iconContainer}
//           >
//             {props.data.map((man, index) => {
//               return (
//                 <Grid
//                   item
//                   key={index}
//                   className={clsx(
//                     classes.dotItem,
//                     currentIndex === index ? classes.activeDot : undefined
//                   )}
//                 />
//               );
//             })}
//           </Grid>
//         </Hidden>

//         <Grid
//           item
//           lg={9}
//           md={9}
//           sm={12}
//           xs={12}
//           container
//           alignItems="center"
//           justify="space-between"
//           // className={classes.caroiselContainer}
//         >
//           <Swiper
//             {...params}
//             ref={swiperRef}
//             autoplay={{ delay: 500 }}
//             loop={true}
//             // activeSlideKey={value}
//             // spaceBetween={10}
//             wrapperClass={classes.caroiselContainer}
//             // slidesPerView={2}
//             // direction="vertical"
//             // autoplay={{ delay: 2000, reverseDirection: true }}
//             // navigation={{ nextEl: <div>next</div>, prevEl: <div>prev</div> }}
//             // pagination={{ clickable: false }}
//             // // scrollbar={{ draggable: true }}
//             // onSwiper={(swiper) => console.log(swiper)}
//             // onSlideChange={() => console.log("slide change")}
//           >
//             {props.data.map((man, index) => {
//               return (
//                 <Grid item key={index}>
//                   <PortFolioItem data={man} />
//                 </Grid>
//               );
//             })}
//           </Swiper>
//         </Grid>
//         <Hidden mdDown>
//           <Grid
//             item
//             lg={2}
//             container
//             alignItems="center"
//             direction="column"
//             justify="center"
//             className={classes.iconContainer}
//           >
//             <Grid item>
//               <IconButton onClick={goNext}>
//                 <ArrowUpward className={classes.arrowIcon} />
//               </IconButton>
//             </Grid>
//             <Grid item>
//               <IconButton onClick={goPrev}>
//                 <ArrowDownward className={classes.arrowIcon} />
//               </IconButton>
//             </Grid>
//           </Grid>
//         </Hidden>
//       </Grid>
//     </div>
//   );
// };
// export default AbhiprayCarousel;
